import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from '../auth/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private snackBar: MatSnackBar, private auth: AuthService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        // 401 z naszego backendu (token brak/wygasl/nieprawidlowy - patrz
        // JwtAuthGuard) - zamiast pokazywac nieczytelny blad, od razu
        // czyscimy sesje i odsylamy do logowania. Dziala niezaleznie od
        // AuthGuard - lapie tez odswiezenia w tle na juz otwartej stronie.
        if (error.status === 401 && this.isOwnBackend(req.url)) {
          this.auth.logout();
          return throwError(error);
        }

        const message = this.getErrorMessage(error);

        this.snackBar.open(message, 'OK', {
          duration: 5000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
        });

        return throwError(error);
      }),
    );
  }

  private isOwnBackend(url: string): boolean {
    return url.includes('apioffice.next77.pl') || url.includes('localhost:3000');
  }

  private getErrorMessage(error: HttpErrorResponse): string {
    console.log(error);
    if (error.error?.message) {
      return Array.isArray(error.error.message)
        ? error.error.message.join(', ')
        : error.error.message;
    }

    if (error.message) {
      return error.message;
    }

    return 'Wystąpił nieoczekiwany błąd.';
  }
}
